module.exports = __webpack_public_path__ + "img/boat-10.57b603bc.jpg";